import registerComment from '../../../common/comments/index';
import presentationalComponent from './CommentThread';
import containerComponent from './CommentThreadContainer';

import { TOOLBAR_TOOLS, TOOL_SETS } from '../../workspace/toolbar/config/toolbarToolConfig';

export default () =>
    registerComment({
        containerComponent,
        presentationalComponent,
        tools: {
            selected: [
                TOOLBAR_TOOLS.COLOR,
                TOOLBAR_TOOLS.DETACH_COMMENT,
                TOOLBAR_TOOLS.MOVE_TO_TRASH,
                TOOLBAR_TOOLS.COLLAPSE,
                ...TOOL_SETS.MULTI_SELECT_ARRANGEMENT,
                ...TOOL_SETS.TRAILING_SELECTED,
            ],
            editing: [...TOOL_SETS.TEXT_EDITING_INLINE],
        },
    });
